const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
    APPS: "apps",
    REVIEWS: "reviews",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("googlePlay.detail") || "Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: false,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("googlePlay.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.APPS,
        label: that?.$t("googlePlay.apps") || "Apps",
        icon: {
            type: "material-icons",
            name: "android",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.REVIEWS,
        label: that?.$t("googlePlay.reviews") || "Reviews",
        icon: {
            type: "material-icons",
            name: "star",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
